<template>
    <div class="container">
        <div class="properties">
            <div class="properties-fields">
                Name: <input v-model="geofence.name"></input>
            </div>
            <!--
            <template v-if="geofence.kind == 'template'">
                <b> (Template)</b>
                Test Template With: <select v-model="geofence.template">
                    <option :value="null">(None)</option>
                    <option v-for="geofence in regularGeofences" :value="geofence.id">{{ geofence.name }}</option>
                </select>
            </template>
            <template v-else>
                Template: <select v-model="geofence.template">
                    <option :value="null">(None)</option>
                    <option v-for="geofence in templateGeofences" :value="geofence.id">{{ geofence.name }}</option>
                </select>
            </template>
            -->
            <div class="properties-buttons">
                <portal-target name="destination">
                </portal-target>
            </div>
        </div>
        <div class="palette-container">
            <node-palette @create="handleCreate"></node-palette>
        </div>
        <expression-tree ref="expression" class="tree" :geofence="geofence"></expression-tree>
    </div>
</template>

<script>
import ExpressionTree from "@/components/ExpressionTree.vue";
import NodePalette from './NodePalette.vue';

import geofences from "@/geofences.js";

export default {
    props: {
        geofence: { type: Object, required: true }
    },
    computed: {
        regularGeofences() { return geofences.regularGeofences; },
        templateGeofences() { return geofences.templateGeofences; }
    },
    components: { ExpressionTree, NodePalette },
    methods: {
        handleCreate(constructor) {
            this.$refs.expression.createNodeUnderRoot(constructor);
        }
    }
}
</script>

<style lang="less" scoped>
.container
{
    display: flex;
    flex-direction: column;
}
.properties
{
    flex-grow: 0;
    padding: 8px;
    border-bottom: 1px solid silver;
    background-color: #f0f0f0;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.properties-fields
{
    font-size: 13.3px;
    flex: 1;

    input
    {
        border: none;
        padding: 4px;
    }
}
.properties-buttons
{
}
.tree
{
    flex-grow: 1;
}
.palette-container
{
    border-bottom: 1px solid silver;
    background-color: #f0f0f0;
}
.floating-buttons
{
    position: absolute;
    right: 8px;
    top: 8px;
}
</style>
